export var FileFormat;
(function (FileFormat) {
    FileFormat["FILE_FORMAT_JSON"] = "JSON";
    FileFormat["FILE_FORMAT_AVRO"] = "AVRO";
    FileFormat["FILE_FORMAT_PARQUET"] = "PARQUET";
    FileFormat["FILE_FORMAT_CSV"] = "CSV";
})(FileFormat || (FileFormat = {}));
